import { PHASE_PRODUCTION_BUILD } from 'next/dist/shared/lib/constants';

export function isProductionBuildOrDevelopement() {
    return PHASE_PRODUCTION_BUILD === process.env.NEXT_PHASE || process.env.NODE_ENV === 'development';
}
